/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
import CPM from 'pages/dashboard/analytics/detail/metrics/cpm/cpm';
import { displayMessage } from "state/actions/message_status";
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import { getDetailRevenueMetrics, updateDetailDateRange } from 'state/actions/detailViewState/detailViewStatus';
import { updataDetailDropDown, fetchRONSites, fetchCountries, clearDetailState } from 'state/actions/detailViewState/detailViewStatus';




/* ========== ~~~~~~~~~~ PAGE : DATA DETAIL METRIC : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state


const mapStateToProps = ({ detailViewStatus, homeState, sessionStatus, accountData }) => {
    const { homeAnalyticsStatus } = homeState;
return {

    devices: detailViewStatus.devices,
    selectedDevices: detailViewStatus.selectedDevices,
    countries: detailViewStatus.countries,
    countriesReceived: detailViewStatus.countriesReceived,
    selectedCountries: detailViewStatus.selectedCountries,
    ronSites: detailViewStatus.ronSites,
    ronSitesReceived: detailViewStatus.ronSitesReceived,
    sites: accountData.sites,
    sitesReceived: accountData.sitesReceived,
    selectedSites: detailViewStatus.selectedSites,
    selectedRevenueType: homeAnalyticsStatus.selectedRevenueType,
    dateRange: detailViewStatus.dateRange,

    cpmDetail: detailViewStatus.cpmDetail,
    fetchingRevenue: detailViewStatus.fetchingRevenue,

    accountUUID: sessionStatus.accountUUID
}};

// map actions
const mapDispatchToProps = dispatch => ({
    displayMessage: message => dispatch(displayMessage(message)),
    updateDateRange: range => dispatch(updateDetailDateRange(range)),
    updateDetailDropDown: (items, itemType) => dispatch(updataDetailDropDown(items, itemType)),
    fetchCountries: (accountUUID, paramString) => dispatch(fetchCountries(accountUUID, paramString)),
    fetchRONSites: (accountUUID, paramString) => dispatch(fetchRONSites(accountUUID, paramString)),
    getDetailRevenueMetrics: (paramString, dataType) => dispatch(getDetailRevenueMetrics(paramString, dataType)),
    clearDetailState: () => dispatch(clearDetailState())
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CPM);